module.exports = __webpack_public_path__ + "static/media/ml-object-description.a23f25f8.gif";